export class SvcAliases {
    private constructor() { }
    static readonly Engine = "MobEngine";
    static readonly Scene3D = "MobScene3D";
    static readonly Store = "MobStore";
    static readonly Screen = "MobScreen";
}